import { PAYWALL_TYPE } from '../actions/types';

const defaultState = 'spid';

/* eslint-disable import/prefer-default-export */
export const paywallTypeReducer = (state = defaultState, action) => {
    if (action.type === PAYWALL_TYPE) {
        return action.payload;
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/paywall-type.js
 **/